import { isNativeApp } from 'shared/javascripts/util/detection'

up.compiler('[data-jump-to-next-video]', (element: HTMLElement) => {
  function getNextVideoLink(): HTMLElement | null {
    const videoLinks = element.querySelectorAll<HTMLElement>('[video-link]')

    let nextVideoLink: HTMLElement | null = null
    let linkFound = false

    videoLinks.forEach((videoLink) => {
      if (linkFound) {
        nextVideoLink = videoLink
        linkFound = false
      }
      if (videoLink.matches('.-active')) {
        linkFound = true
      }
    })

    return nextVideoLink
  }

  function jumpToNextVideo(): boolean {
    const nextVideoLink = getNextVideoLink()
    if (!nextVideoLink) return false

    up.follow(nextVideoLink)
    return true
  }

  up.on(element, 'playbackfinished.player', () => {
    if (isNativeApp()) {
      jumpToNextVideo()
    }
  })
})
